module.exports = __webpack_public_path__ + "static/img/ppt.46479ecc.svg";